import React from "react";
import { Table } from "semantic-ui-react";
import Cell from "./Cell";

export default function ReportTable(props) {
  const { device, data } = props;
  console.log(data);
  return (
    <React.Fragment>
      <Table unstackable compact celled textAlign="center">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Timestamp</Table.HeaderCell>
            {device.channels.map((item, index) => {
              return (
                <Table.HeaderCell key={index}>
                  {item.name + " (" + item.unit + ")"}
                </Table.HeaderCell>
              );
            })}
          </Table.Row>
        </Table.Header>
        <Table.Body
          children={data.map(item => {
            const { Temperature, RH, DP, Connected } = item.payload.data;
            return (
              <Table.Row key={item.sk}>
                <Table.Cell>{item.sk}</Table.Cell>
                <Cell {...Temperature} Connected={Connected} />
                <Cell {...RH} Connected={Connected} />
                <Cell {...DP} Connected={Connected} />
              </Table.Row>
            );
          })}
        />
      </Table>
    </React.Fragment>
  );
}
